import React from "react";

const SelectTab = () => {
  return <h4>Select a tab to begin...</h4>;
};

export default SelectTab;
